var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"visual-compass"},[_c('img',{attrs:{"src":_vm.pathImg,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }